import * as React from 'react';

import Loader from 'bundles/degree-home/components/Loader';
import SummaryCourseItem from 'bundles/degree-home/components/SummaryCourseItem';
import type { NormalizedNotStartedCourse } from 'bundles/degree-home/components/v2/types/courseStates';

import _t from 'i18n!nls/degree-home';

import { SummaryCard } from './SummaryCard';

type Props = {
  loading: boolean;
  notStartedCourses?: Array<NormalizedNotStartedCourse>;
};

export const NotStartedCourses = ({ loading, notStartedCourses }: Props) => (
  <SummaryCard title={_t('Upcoming')}>
    {loading && <Loader />}
    {!loading &&
      notStartedCourses?.map((notStartedCourse) => {
        const isCourseEnrollable = notStartedCourse.hasEnrollableSession && !notStartedCourse.activeSessionId;

        return (
          <SummaryCourseItem
            key={notStartedCourse.id}
            courseId={notStartedCourse.id}
            courseName={notStartedCourse.name}
            courseSlug={notStartedCourse.slug}
            statusText={_t('Not started')}
            isCourseEnrollable={isCourseEnrollable}
          />
        );
      })}
  </SummaryCard>
);

export default NotStartedCourses;
